import { MuiStylesType } from 'model/muiStyles.model';

export const muiStyles: MuiStylesType = {
  root: {
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
  },
};
